var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWhatsappIcon),expression:"showWhatsappIcon"}],staticClass:"whatsapp-flotado",attrs:{"href":"https://api.whatsapp.com/send?phone=543434532596&text=Por%20favor%20requiero%20más%20información%20WEB%20Gracias"}},[_c('i',{staticClass:"mdi mdi-whatsapp"})])
}
var staticRenderFns = []

export { render, staticRenderFns }